import * as React from 'react';
import { Grid, SxProps, Theme } from '@mui/material';

type JustifyContent = 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
type AlignItems = 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
type Direction = 'row' | 'row-reverse' | 'column' | 'column-reverse';
type Spacing = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
type Wrap = 'nowrap' | 'wrap' | 'wrap-reverse';
type Size = false | 'auto' | true | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type Xs = Size;
type Sm = Size;
type Md = Size;
type Lg = Size;
type Xl = Size;

export interface LayoutGridProps {
  alignItems?: AlignItems;
  className?: string;
  sx?: SxProps<Theme>;
  container?: boolean;
  component?: string | React.Component | any;
  direction?: Direction;
  item?: boolean;
  justify?: JustifyContent;
  spacing?: Spacing;
  wrap?: Wrap;
  xs?: Xs;
  sm?: Sm;
  md?: Md;
  lg?: Lg;
  xl?: Xl;
  onKeyDown?: Function;
  onKeyUp?: Function;
}

const LayoutGrid: React.FunctionComponent<LayoutGridProps> = ({ className, component, justify, ...rest }) => {
  return <Grid justifyContent={justify} component={component} className={className} {...rest} />;
};

LayoutGrid.displayName = 'LayoutGrid';

export { LayoutGrid };
